import FanAva from '../assets/images/FanAva.svg'
import Mellat from '../assets/images/Mellat Bank.svg'
import Sina from '../assets/images/Sina.svg'
import Tara from '../assets/images/Tara.png'
import Zarin from '../assets/images/Zarin.svg'
import gatwWayDefault from '../assets/images/gatwWayDefault.svg'
import Saman from '../assets/images/saman.svg'
import { GatewayType } from '../types/gateway'

export const gatewayLogo = (gateWayType: GatewayType) => {
  switch (gateWayType) {
    case 'Fanava':
      return FanAva
    case 'Mellat':
      return Mellat
    case 'Saman':
      return Saman
    case 'Top':
      return Sina
    case 'Zarinpal':
      return Zarin
    case 'Tara':
      return Tara
    default:
      return gatwWayDefault
  }
}
